import { render, staticRenderFns } from "./CaptureNationalIdFront.vue?vue&type=template&id=2878703e&"
import script from "./CaptureNationalIdFront.vue?vue&type=script&lang=ts&"
export * from "./CaptureNationalIdFront.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports